var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path3, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _path4, _rect38, _g, _rect39, _rect40, _path5, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _path6, _rect153;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCiudad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2562.73 929.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#dde8fd;}.cls-3{fill:#c5d7e8;}.cls-4{fill:#f0f6ff;}.cls-5{opacity:0.8;}.cls-6{fill:#c8dfed;}.cls-7{fill:#c1d8e8;}.cls-8{fill:#afc3d3;}.cls-9{fill:#bed2fa;}.cls-10{fill:#7d96d4;}.cls-11{fill:#3489b4;}.cls-12{fill:#060632;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CIUDAD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2383.89,921.29s-121.51.2-306.84.59c-542.66,1-1632.82,2.77-1823,1.88C-1.12,922.57-177.66,262.25,299.5,307.11,817.76,355.71,438.7,58.35,744,9.05,1076.2-44.69,1143.18,162,1381.76,77.52,1707.87-38,1885,2.24,1998.51,86.5,2123,179,2170.7,324.49,2254.28,375.37c1.88,1.19,3.75,2.27,5.63,3.26,162.41,88.91,235.91,175,259.92,251.33C2573.38,799.38,2383.89,921.29,2383.89,921.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1761.41,49.08a29.36,29.36,0,1,0,29.36,29.36A29.36,29.36,0,0,0,1761.41,49.08Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1381.36,
    y: 144.91,
    width: 138.99,
    height: 675.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1412.57,
    y: 144.91,
    width: 138.99,
    height: 675.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1412.61,
    y: 144.73,
    width: 138.96,
    height: 39.06,
    transform: "translate(2964.17 328.52) rotate(180)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1412.61,
    y: 229.44,
    width: 138.96,
    height: 39.06,
    transform: "translate(2964.17 497.94) rotate(180)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1412.61,
    y: 314.15,
    width: 138.96,
    height: 39.06,
    transform: "translate(2964.17 667.35) rotate(180)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1412.61,
    y: 398.86,
    width: 138.96,
    height: 39.06,
    transform: "translate(2964.17 836.77) rotate(180)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1412.61,
    y: 483.57,
    width: 138.96,
    height: 39.06,
    transform: "translate(2964.17 1006.19) rotate(180)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1412.61,
    y: 568.28,
    width: 138.96,
    height: 39.06,
    transform: "translate(2964.17 1175.61) rotate(180)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1412.61,
    y: 652.99,
    width: 138.96,
    height: 39.06,
    transform: "translate(2964.17 1345.03) rotate(180)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1412.61,
    y: 737.69,
    width: 138.96,
    height: 39.06,
    transform: "translate(2964.17 1514.45) rotate(180)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1603.55,
    y: 240.55,
    width: 138.99,
    height: 580.26
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1634.76,
    y: 240.55,
    width: 138.99,
    height: 580.26
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1634.8,
    y: 240.4,
    width: 138.96,
    height: 33.53,
    transform: "translate(3408.55 514.32) rotate(180)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1634.8,
    y: 313.12,
    width: 138.96,
    height: 33.53,
    transform: "translate(3408.55 659.77) rotate(180)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1634.8,
    y: 385.84,
    width: 138.96,
    height: 33.53,
    transform: "translate(3408.55 805.21) rotate(180)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1634.8,
    y: 458.56,
    width: 138.96,
    height: 33.53,
    transform: "translate(3408.55 950.66) rotate(180)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1634.8,
    y: 531.29,
    width: 138.96,
    height: 33.53,
    transform: "translate(3408.55 1096.1) rotate(180)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1634.8,
    y: 604.01,
    width: 138.96,
    height: 33.53,
    transform: "translate(3408.55 1241.55) rotate(180)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1634.8,
    y: 676.73,
    width: 138.96,
    height: 33.53,
    transform: "translate(3408.55 1386.99) rotate(180)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1634.8,
    y: 749.45,
    width: 138.96,
    height: 33.53,
    transform: "translate(3408.55 1532.44) rotate(180)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1306.13,
    y: 800.07,
    width: 58.2,
    height: 84.87,
    transform: "translate(2670.47 1685.02) rotate(180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1323.91,684.29V919.93H707.38l-4.2,0-157.34-1.48c-.13-.23-.29-.51-.48-.82s-.56-1-.92-1.6c-.11-.22-.24-.44-.38-.68-.47-.83-1-1.77-1.59-2.85-.72-1.31-1.52-2.81-2.41-4.47h0c-3.31-6.2-7.7-14.8-12.68-25.49q-2.46-5.26-5.09-11.2c-.7-1.58-1.39-3.18-2.11-4.82h0c-.69-1.59-1.37-3.2-2.06-4.86a1.11,1.11,0,0,1-.07-.16c-.48-1.13-1-2.28-1.44-3.46s-1-2.4-1.51-3.63c-2.58-6.32-5.21-13-7.83-20.13l-.21-.56h0q-2.56-7-5.12-14.36-1.4-4.06-2.77-8.26l-.17-.52c-.4-1.24-.8-2.48-1.21-3.73-.33-1.06-.67-2.12-1-3.18-.69-2.19-1.38-4.41-2.06-6.64-.87-2.88-1.74-5.8-2.59-8.74q-1.72-6-3.37-12.23c-.33-1.24-.66-2.49-1-3.74-1-3.74-1.92-7.54-2.83-11.37-.3-1.24-.59-2.47-.88-3.71-.18-.77-.36-1.53-.53-2.3q-2.08-9.1-3.93-18.57-2-10.41-3.73-21.21c-1-6.64-2-13.39-2.77-20.23q-1.15-9.68-1.95-19.6c-1.25-15.46-1.83-31.34-1.58-47.51a442.74,442.74,0,0,1,9.72-86.63c.23-1.07.47-2.14.7-3.21q2.36-10.5,5.3-21,2.24-8,4.85-16.08,1.89-5.83,4-11.67,4.74-13.22,10.53-26.42H508v-7.31c21-45.38,52-90.34,96.17-132.87l2.47-2.37h2.58v90.13H689V263.44h88v95.35h20.07V245h88V458.37H996.4V582.82H1038v31.35h95.54v-54h54.86V413.49h67.76v270.8Z"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 797.06,
    y: 259.37,
    width: 88.07,
    height: 21.74,
    transform: "translate(1682.18 540.47) rotate(180)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 797.06,
    y: 300.21,
    width: 88.07,
    height: 21.75,
    transform: "translate(1682.18 622.18) rotate(180)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 797.06,
    y: 336.97,
    width: 88.07,
    height: 21.74,
    transform: "translate(1682.18 695.68) rotate(180)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 688.99,
    y: 336.97,
    width: 88.07,
    height: 21.74,
    transform: "translate(1466.04 695.68) rotate(180)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 688.99,
    y: 300.21,
    width: 88.07,
    height: 21.75,
    transform: "translate(1466.04 622.18) rotate(180)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 688.99,
    y: 263.52,
    width: 88.07,
    height: 21.74,
    transform: "translate(1466.04 548.78) rotate(180)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 688.96,
    y: 372.6,
    width: 196.16,
    height: 21.75,
    transform: "translate(1574.09 766.95) rotate(180)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 688.96,
    y: 408.24,
    width: 196.16,
    height: 21.74,
    transform: "translate(1574.09 838.22) rotate(180)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1187.76,
    y: 413.5,
    width: 68.36,
    height: 33.56,
    transform: "translate(2443.88 860.57) rotate(180)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1187.76,
    y: 463.42,
    width: 68.36,
    height: 33.57,
    transform: "translate(2443.88 960.4) rotate(180)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1187.76,
    y: 513.34,
    width: 68.36,
    height: 33.56,
    transform: "translate(2443.88 1060.24) rotate(180)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1187.76,
    y: 565.66,
    width: 68.36,
    height: 33.57,
    transform: "translate(2443.88 1164.88) rotate(180)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1187.76,
    y: 616.36,
    width: 68.36,
    height: 33.57,
    transform: "translate(2443.88 1266.29) rotate(180)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1187.76,
    y: 667.07,
    width: 68.36,
    height: 33.56,
    transform: "translate(2443.88 1367.7) rotate(180)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1187.76,
    y: 720.11,
    width: 68.36,
    height: 33.56,
    transform: "translate(2443.88 1473.79) rotate(180)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 688.96,
    y: 443.06,
    width: 196.16,
    height: 13.8,
    transform: "translate(1574.09 899.93) rotate(180)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1163.51,
    y: 413.5,
    width: 25.2,
    height: 146.68
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1082.83,
    y: 560.18,
    width: 50.7,
    height: 53.99
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M689,263.52v21.75l0,87.33v37.71H671.49V265.25l2.35-1.73Z"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 786.31,
    y: 244.96,
    width: 10.74,
    height: 113.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 963.29,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1941.49 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 935.38,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1885.69 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 908.1,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1831.13 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 882.24,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1779.4 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 855.88,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1726.68 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 829.21,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1673.35 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 801.31,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1617.54 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 774.03,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1562.98 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 748.17,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1511.25 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 721.81,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1458.53 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 694.33,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1403.59 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 666.43,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1347.78 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 639.15,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1293.22 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 613.29,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1241.5 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 586.93,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1188.77 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 560.26,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1135.45 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 532.36,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1079.64 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 505.08,
    y: 479.78,
    width: 14.92,
    height: 21.03,
    transform: "translate(1025.08 980.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M494.14,489.15v11.67h-4Q492.05,495,494.14,489.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 963.29,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1941.49 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 935.38,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1885.69 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 908.1,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1831.13 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 882.24,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1779.4 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 855.88,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1726.68 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 829.21,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1673.35 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 801.31,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1617.54 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 774.03,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1562.98 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 748.17,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1511.25 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 721.81,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1458.53 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 694.33,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1403.59 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 666.43,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1347.78 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 639.15,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1293.22 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 613.29,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1241.5 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 586.93,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1188.77 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 560.26,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1135.45 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 532.36,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1079.64 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 505.08,
    y: 516.9,
    width: 14.92,
    height: 21.03,
    transform: "translate(1025.08 1054.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M494.14,516.9v21H480q2.36-10.5,5.3-21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 963.29,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1941.49 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 935.38,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1885.69 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 908.1,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1831.13 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 882.24,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1779.4 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 855.88,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1726.68 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 829.21,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1673.35 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 801.31,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1617.54 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 774.03,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1562.98 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 748.17,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1511.25 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 721.81,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1458.53 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 694.33,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1403.59 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 666.43,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1347.78 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 639.15,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1293.22 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 613.29,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1241.5 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 586.93,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1188.77 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 560.26,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1135.45 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 532.36,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1079.64 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 505.08,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(1025.08 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 479.21,
    y: 553.44,
    width: 14.92,
    height: 21.03,
    transform: "translate(973.35 1127.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 963.29,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1941.49 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 935.38,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1885.69 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 908.1,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1831.13 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 882.24,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1779.4 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 855.88,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1726.68 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 829.21,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1673.35 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 801.31,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1617.54 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 774.03,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1562.98 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 748.17,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1511.25 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 721.81,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1458.53 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 694.33,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1403.59 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 666.43,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1347.78 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 639.15,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1293.22 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 613.29,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1241.5 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 586.93,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1188.77 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 560.26,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1135.45 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 532.36,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1079.64 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 505.08,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(1025.08 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 479.21,
    y: 592.27,
    width: 14.92,
    height: 21.03,
    transform: "translate(973.35 1205.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 963.29,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1941.49 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 935.38,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1885.69 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 908.1,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1831.13 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 882.24,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1779.4 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 855.88,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1726.68 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 829.21,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1673.35 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 801.31,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1617.54 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 774.03,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1562.98 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 748.17,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1511.25 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 721.81,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1458.53 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 694.33,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1403.59 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 666.43,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1347.78 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 639.15,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1293.22 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 613.29,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1241.5 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 586.93,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1188.77 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 560.26,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1135.45 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 532.36,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1079.64 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 505.08,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(1025.08 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 479.21,
    y: 629.39,
    width: 14.92,
    height: 21.03,
    transform: "translate(973.35 1279.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 963.29,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1941.49 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 935.38,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1885.69 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 908.1,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1831.13 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 882.24,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1779.4 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 855.88,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1726.68 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 829.21,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1673.35 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 801.31,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1617.54 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 774.03,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1562.98 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 748.17,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1511.25 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 721.81,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1458.53 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 694.33,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1403.59 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 666.43,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1347.78 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 639.15,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1293.22 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 613.29,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1241.5 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 586.93,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1188.77 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 560.26,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1135.45 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 532.36,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1079.64 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 505.08,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(1025.08 1352.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 479.21,
    y: 665.93,
    width: 14.92,
    height: 21.03,
    transform: "translate(973.35 1352.9) rotate(180)"
  }))), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 736.98,
    y: 731.83,
    width: 345.85,
    height: 186.58,
    transform: "translate(1819.82 1650.23) rotate(180)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 999.23,
    y: 825.12,
    width: 345.85,
    height: 93.29,
    transform: "translate(2344.32 1743.53) rotate(180)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M709.25,760.9V918.41H545.84c-.13-.23-.29-.51-.48-.82s-.56-1-.92-1.6c-.11-.22-.24-.44-.38-.68-.47-.83-1-1.77-1.59-2.85-.72-1.31-1.52-2.81-2.41-4.47h0c-3.31-6.2-7.7-14.8-12.68-25.49q-2.46-5.26-5.09-11.2c-.7-1.58-1.39-3.18-2.11-4.82h0c-.69-1.59-1.37-3.2-2.06-4.86a1.11,1.11,0,0,1-.07-.16c-.48-1.13-1-2.28-1.44-3.46s-1-2.4-1.51-3.63c-2.58-6.32-5.21-13-7.83-20.13l-.21-.56h0q-2.56-7-5.12-14.36-1.4-4.06-2.77-8.26l-.17-.52c-.4-1.24-.8-2.48-1.21-3.73-.33-1.06-.67-2.12-1-3.18-.69-2.19-1.38-4.41-2.06-6.64-.87-2.88-1.74-5.8-2.59-8.74q-1.72-6-3.37-12.23c-.33-1.24-.66-2.49-1-3.74-1-3.74-1.92-7.54-2.83-11.37Z"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 995.29,
    y: 753.68,
    width: 64.44,
    height: 34.56,
    transform: "translate(2055.02 1541.91) rotate(180)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 912.58,
    y: 753.68,
    width: 64.44,
    height: 34.56,
    transform: "translate(1889.59 1541.91) rotate(180)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 831.44,
    y: 753.68,
    width: 64.44,
    height: 34.56,
    transform: "translate(1727.31 1541.91) rotate(180)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 751.86,
    y: 753.68,
    width: 64.44,
    height: 34.56,
    transform: "translate(1568.16 1541.91) rotate(180)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 707.38,
    y: 731.83,
    width: 33.2,
    height: 188.19,
    transform: "translate(1447.95 1651.84) rotate(180)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1240.71,
    y: 398.9,
    width: 1.8,
    height: 14.61,
    transform: "translate(2483.23 812.4) rotate(180)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1176.13,
    y: 398.9,
    width: 1.8,
    height: 14.61,
    transform: "translate(2354.05 812.4) rotate(180)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1279.62,
    y: 757.19,
    width: 237.47,
    height: 159.7,
    transform: "translate(2796.7 1674.09) rotate(180)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1279.62,
    y: 736.33,
    width: 237.47,
    height: 51.91,
    transform: "translate(2796.7 1524.56) rotate(180)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1488.72,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2989.63 1624.42) rotate(180)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1465.91,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2944.02 1624.42) rotate(180)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1443.62,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2899.43 1624.42) rotate(180)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1422.48,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2857.15 1624.42) rotate(180)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1400.93,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2814.06 1624.42) rotate(180)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1379.14,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2770.47 1624.42) rotate(180)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1356.33,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2724.86 1624.42) rotate(180)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1334.04,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2680.27 1624.42) rotate(180)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1312.9,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2637.99 1624.42) rotate(180)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1291.35,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(2594.9 1624.42) rotate(180)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1488.72,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2989.63 1685.09) rotate(180)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1465.91,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2944.02 1685.09) rotate(180)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1443.62,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2899.43 1685.09) rotate(180)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1422.48,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2857.15 1685.09) rotate(180)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1400.93,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2814.06 1685.09) rotate(180)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1379.14,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2770.47 1685.09) rotate(180)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1356.33,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2724.86 1685.09) rotate(180)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1334.04,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2680.27 1685.09) rotate(180)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1312.9,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2637.99 1685.09) rotate(180)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1291.35,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(2594.9 1685.09) rotate(180)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1488.72,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2989.63 1744.83) rotate(180)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1465.91,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2944.02 1744.83) rotate(180)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1443.62,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2899.43 1744.83) rotate(180)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1422.48,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2857.15 1744.83) rotate(180)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1400.93,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2814.06 1744.83) rotate(180)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1379.14,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2770.47 1744.83) rotate(180)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1356.33,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2724.86 1744.83) rotate(180)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1334.04,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2680.27 1744.83) rotate(180)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1312.9,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2637.99 1744.83) rotate(180)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1291.35,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(2594.9 1744.83) rotate(180)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1488.72,
    y: 750.91,
    width: 10.25,
    height: 17.73,
    transform: "translate(2987.69 1519.55) rotate(180)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1386.97,
    y: 750.91,
    width: 10.25,
    height: 17.73,
    transform: "translate(2784.2 1519.55) rotate(180)"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1306.04,
    y: 750.91,
    width: 10.25,
    height: 17.73,
    transform: "translate(2622.32 1519.55) rotate(180)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1532,
    y: 757.19,
    width: 237.47,
    height: 159.7,
    transform: "translate(3301.46 1674.09) rotate(180)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1532,
    y: 736.33,
    width: 237.47,
    height: 51.91,
    transform: "translate(3301.46 1524.56) rotate(180)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1741.1,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3494.4 1624.42) rotate(180)"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1718.3,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3448.79 1624.42) rotate(180)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1696,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3404.19 1624.42) rotate(180)"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1674.86,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3361.91 1624.42) rotate(180)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1653.31,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3318.82 1624.42) rotate(180)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1631.52,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3275.24 1624.42) rotate(180)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1608.71,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3229.62 1624.42) rotate(180)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1586.42,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3185.03 1624.42) rotate(180)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1565.28,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3142.75 1624.42) rotate(180)"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1543.73,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(3099.66 1624.42) rotate(180)"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1741.1,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3494.4 1685.09) rotate(180)"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1718.3,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3448.79 1685.09) rotate(180)"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1696,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3404.19 1685.09) rotate(180)"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1674.86,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3361.91 1685.09) rotate(180)"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1653.31,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3318.82 1685.09) rotate(180)"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1631.52,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3275.24 1685.09) rotate(180)"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1608.71,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3229.62 1685.09) rotate(180)"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1586.42,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3185.03 1685.09) rotate(180)"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1565.28,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3142.75 1685.09) rotate(180)"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1543.73,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(3099.66 1685.09) rotate(180)"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1741.1,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3494.4 1744.83) rotate(180)"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1718.3,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3448.79 1744.83) rotate(180)"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1696,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3404.19 1744.83) rotate(180)"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1674.86,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3361.91 1744.83) rotate(180)"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1653.31,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3318.82 1744.83) rotate(180)"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1631.52,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3275.24 1744.83) rotate(180)"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1608.71,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3229.62 1744.83) rotate(180)"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1586.42,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3185.03 1744.83) rotate(180)"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1565.28,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3142.75 1744.83) rotate(180)"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1543.73,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(3099.66 1744.83) rotate(180)"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1741.1,
    y: 750.91,
    width: 10.25,
    height: 17.73,
    transform: "translate(3492.45 1519.55) rotate(180)"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1639.36,
    y: 750.91,
    width: 10.25,
    height: 17.73,
    transform: "translate(3288.96 1519.55) rotate(180)"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1558.42,
    y: 750.91,
    width: 10.25,
    height: 17.73,
    transform: "translate(3127.09 1519.55) rotate(180)"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2029.04,
    y: 757.19,
    width: 237.47,
    height: 159.7,
    transform: "translate(4295.55 1674.09) rotate(180)"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2029.04,
    y: 736.33,
    width: 237.47,
    height: 51.91,
    transform: "translate(4295.55 1524.56) rotate(180)"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2238.14,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4488.48 1624.42) rotate(180)"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2215.34,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4442.87 1624.42) rotate(180)"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2193.04,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4398.28 1624.42) rotate(180)"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2171.9,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4356 1624.42) rotate(180)"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2150.35,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4312.91 1624.42) rotate(180)"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2128.56,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4269.32 1624.42) rotate(180)"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2105.76,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4223.71 1624.42) rotate(180)"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2083.46,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4179.12 1624.42) rotate(180)"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2062.32,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4136.84 1624.42) rotate(180)"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2040.77,
    y: 803.62,
    width: 12.2,
    height: 17.19,
    transform: "translate(4093.75 1624.42) rotate(180)"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2238.14,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4488.48 1685.09) rotate(180)"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2215.34,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4442.87 1685.09) rotate(180)"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2193.04,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4398.28 1685.09) rotate(180)"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2171.9,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4356 1685.09) rotate(180)"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2150.35,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4312.91 1685.09) rotate(180)"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2128.56,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4269.32 1685.09) rotate(180)"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2105.76,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4223.71 1685.09) rotate(180)"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2083.46,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4179.12 1685.09) rotate(180)"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2062.32,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4136.84 1685.09) rotate(180)"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2040.77,
    y: 833.95,
    width: 12.2,
    height: 17.19,
    transform: "translate(4093.75 1685.09) rotate(180)"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2238.14,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4488.48 1744.83) rotate(180)"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2215.34,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4442.87 1744.83) rotate(180)"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2193.04,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4398.28 1744.83) rotate(180)"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2171.9,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4356 1744.83) rotate(180)"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2150.35,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4312.91 1744.83) rotate(180)"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2128.56,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4269.32 1744.83) rotate(180)"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2105.76,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4223.71 1744.83) rotate(180)"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2083.46,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4179.12 1744.83) rotate(180)"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2062.32,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4136.84 1744.83) rotate(180)"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2040.77,
    y: 863.82,
    width: 12.2,
    height: 17.19,
    transform: "translate(4093.75 1744.83) rotate(180)"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2238.14,
    y: 750.91,
    width: 10.25,
    height: 17.73,
    transform: "translate(4486.53 1519.55) rotate(180)"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2136.4,
    y: 750.91,
    width: 10.25,
    height: 17.73,
    transform: "translate(4283.04 1519.55) rotate(180)"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2055.46,
    y: 750.91,
    width: 10.25,
    height: 17.73,
    transform: "translate(4121.17 1519.55) rotate(180)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2383.89,921.29s-121.51.2-306.84.59c-2.77-1.18-4.25-1.87-4.25-1.87s20.94-114.6,129.61-139.2,110-129.61,177.83-150.56c55.82-17.19,105.7,5.53,139.59-.29C2573.38,799.38,2383.89,921.29,2383.89,921.29Z"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 99.73,
    y: 920.01,
    width: 2463,
    height: 9.53,
    rx: 3.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiudad);
export default __webpack_public_path__ + "static/media/ciudad.ca153752ad87166f4c4b2322d36c3a7c.svg";
export { ForwardRef as ReactComponent };